
import { formatEuros } from '@/utils/paymentOffers'

const PAYMENT_LOGOS = {
  cb: {
    src: require('~/assets/images/payment_cb.png'),
    alt: 'CB',
    class: 'tw-h-4',
  },
  visa: {
    src: require('~/assets/images/payment_visa.png'),
    alt: 'Visa',
    class: 'tw-h-3',
  },
  mastercard: {
    src: require('~/assets/images/payment_mastercard.svg'),
    alt: 'Mastercard',
    class: 'tw-h-5',
  },
  paypal: {
    src: require('~/assets/images/payment_paypal2.png'),
    alt: 'PayPal',
    class: 'tw-h-3',
  },
  apple_pay: {
    src: require('~/assets/images/payment_apple_pay2.png'),
    alt: 'Apple Pay',
    class: 'tw-h-4',
  },
  google_pay: {
    src: require('~/assets/images/payment_google_pay2.png'),
    alt: 'Google Pay',
    class: 'tw-h-4',
  },
  oney: {
    src: require('~/assets/images/payment_oney.png'),
    alt: 'Oney',
    class: 'tw-h-4',
  },
}

export default {
  name: 'HomeTrustBar',

  props: {
    layout: {
      type: String,
      default: 'ticker',
    },
  },

  data() {
    return {
      current: 0,
      paused: false,
      timer: null,
    }
  },

  computed: {
    items() {
      return [
        { key: 'payment' },
        this.shippingItem,
        this.installmentItem,
        {
          key: 'french',
          flag: true,
          to: this.localePath({ name: 'magasin-excideuil' }),
          text: this.$t('pages.index.trustBar.frenchCompanyTitle'),
        },
      ].filter(Boolean)
    },

    shippingItem() {
      const offer = this.$store.getters.free_shipping_offer
      if (!offer) return null

      const amount = this.$options.filters.priceFormatCompact(offer.amount)

      return {
        key: 'shipping',
        icon: ['fal', 'shipping-fast'],
        to: this.localePath({ name: 'livraison' }),
        text: offer.relay
          ? this.$t('pages.index.freeRelayShippingAmount', { amount })
          : this.$t('pages.index.trustBar.freeShippingTitle', { amount }),
      }
    },

    installmentItem() {
      const offers = this.$store.getters.payment_offers
      let text = null

      if (offers.oney) {
        text = this.$t('pages.index.paymentBannerInstalments', {
          minimum: formatEuros(offers.oney.minimum, this.$i18n.locale),
        })
      } else if (offers.paypalCredit) {
        text = this.$t('pages.index.paymentBannerCredit')
      }

      if (!text) return null

      return {
        key: 'installment',
        icon: ['fal', 'calendar-alt'],
        to: this.localePath({ name: 'paiement-securise' }),
        text,
      }
    },

    payments() {
      return this.$store.getters.payment_offers.logos
        .filter(id => PAYMENT_LOGOS[id])
        .map(id => ({ id, ...PAYMENT_LOGOS[id] }))
    },
  },

  mounted() {
    const reduced =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (!reduced && this.layout !== 'row') {
      this.timer = setInterval(() => {
        if (!this.paused) {
          this.current = (this.current + 1) % this.items.length
        }
      }, 4000)
    }
  },

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
}
